import React, { FC } from 'react'

import { useWindowSize } from 'core/hooks/useWindowSize'

import { CardsGrid } from './CardsGrid'

import classes from './style.module.scss'

interface ProductFeatureCardData {
  icon?: string
  text?: string
}

interface ProductFeatureDisplayProps {
  desktopBackgroundUrl: string
  mobileBackgroundUrl: string
  cards: ProductFeatureCardData[]
}

export const ProductFeatureDisplay: FC<ProductFeatureDisplayProps> = ({
  desktopBackgroundUrl,
  mobileBackgroundUrl,
  cards,
}) => {
  const { width } = useWindowSize()
  const isTablet = width <= 860
  const desktopBackground = desktopBackgroundUrl ? `url(${desktopBackgroundUrl})` : 'none'
  const mobileBackground = mobileBackgroundUrl ? `url(${mobileBackgroundUrl})` : 'none'

  return (
    <>
      <div
        className={classes.container}
        style={
          {
            '--desktop-bg': desktopBackground,
            '--mobile-bg': mobileBackground,
          } as React.CSSProperties
        }
      >
        {!isTablet ? (
          <div className={classes.content}>
            <CardsGrid cards={cards} />
          </div>
        ) : null}
      </div>
      {isTablet ? <CardsGrid cards={cards} /> : null}
    </>
  )
}
